{
    "zendesk.login.error.failed": "Échec de la connexion",
    "zendesk.login.error.fingerprintNotReady": "L'empreinte de l'appareil n'est pas encore prête. Réessayez dans une seconde.",
    "zendesk.login.error.forbidden": "Accès interdit aux utilisateurs non Ops.",
    "zendesk.login.error.resendFailed": "Impossible de renvoyer le code de l'appareil",
    "zendesk.login.field.deviceCode": "Code de confirmation de l'appareil",
    "zendesk.login.field.email": "Email",
    "zendesk.login.field.otp": "Code OTP",
    "zendesk.login.field.password": "Mot de passe",
    "zendesk.login.qrCodeHint": "Scannez avec Google Authenticator, puis saisissez le code OTP.",
    "zendesk.login.resendDeviceCode": "Renvoyer le code de l'appareil",
    "zendesk.login.submit": "Se connecter",
    "zendesk.login.title": "Connexion Ops Sharelock",
    "zendesk.sidebar.claims.empty": "Aucun sinistre",
    "zendesk.sidebar.claims.openedAt": "Ouvert le {date}",
    "zendesk.sidebar.error.loadFailed": "Impossible de charger le contexte",
    "zendesk.sidebar.error.noRequester": "Aucun email ni téléphone disponible pour le demandeur du ticket.",
    "zendesk.sidebar.error.requesterUnavailable": "Impossible de charger le demandeur du ticket.",
    "zendesk.sidebar.error.userNotFound": "Aucun utilisateur Sharelock pour {identity}",
    "zendesk.sidebar.logout": "Déconnexion",
    "zendesk.sidebar.policies.empty": "Aucun contrat",
    "zendesk.sidebar.quotes.empty": "Aucun devis en cours",
    "zendesk.sidebar.refresh": "Rafraîchir",
    "zendesk.sidebar.requester": "Demandeur : {requester}",
    "zendesk.sidebar.section.claims": "Sinistres",
    "zendesk.sidebar.section.policies": "Contrats",
    "zendesk.sidebar.section.quotes": "Devis",
    "zendesk.sidebar.section.user": "Utilisateur",
    "zendesk.sidebar.user.createdAt": "Créé le {date}",
    "zendesk.sidebar.user.lastDevice": "Dernière activité de l'appareil",
    "zendesk.sidebar.user.noDevice": "Aucun appareil trouvé",
    "zendesk.sidebar.error.notFound": "Aucun utilisateur ni aucune entreprise Sharelock pour {identity}",
    "zendesk.sidebar.group.noPolicies": "Aucun contrat B2B",
    "zendesk.sidebar.group.partner": "Partenaire",
    "zendesk.sidebar.section.groups": "Entreprises"
}
